import XlsxPopulate from 'xlsx-populate';
/* TODO:リファクタ対象 */
/**
 * fileManager関係で共通の処理をまとめるためのファイル
 */
class FileManager {
  /**
   * fileReaderを用いて、FileObjectをbufferに変換する関数
   * TODO: 読み取り時に使用するものなので、別のとこ(汎用的に使用するものをまとめたとこ)に置きたい
   * @param file
   * @returns 返り値
   */
  public static convertFileToBuffer = async (file: File): Promise<string | ArrayBuffer | null> => {
    const reader = new FileReader();
    if (file instanceof Blob) {
      reader.readAsArrayBuffer(file);
    }
    await new Promise<void>((resolve) => (reader.onload = () => resolve()));
    return reader.result;
  };

  /**
   * XlsxPopulate.fromDataAsyncを用いて、bufferをWorkSheetに変換する関数
   * TODO: 読み取り時に使用するものなので、別のとこ(汎用的に使用するものをまとめたとこ)に置きたい
   * @param blobOrFile
   * @returns 返り値
   */
  public static convertBufferToWorkSheet = async (blobOrFile: string | ArrayBuffer | null): Promise<string | ArrayBuffer | null> => {
    // XlsxPopulate.fromDataAsync(data).then(async function (workbook) {
    const a = await XlsxPopulate.fromDataAsync(blobOrFile);
    // await new Promise<void>((resolve) => (XlsxPopulate.then = () => resolve()));
    return a;
  };

  /**
   * BlobオブジェクトをArrayBufferの形に変換する
   * @param blob blob
   * @returns arraybuffer
   */
  public static blobToArrayBuffer = async (blob: Blob): Promise<ArrayBuffer> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = function (event) {
        if (reader.readyState === FileReader.DONE) {
          resolve(reader.result as ArrayBuffer);
        }
      };
      reader.onerror = () => {
        reject(new Error('Failed to read blob'));
      };
      reader.readAsArrayBuffer(blob);
    });
  };
}

export { FileManager as fm };
